import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import i18n from "i18next";
import { Button, Callout, Tooltip } from "@blueprintjs/core";
import { Trans } from "react-i18next";
import { authenticatedGetFetchBlob } from "../../utils/AuthenticatedFetch";
import { front_basename } from "../..";

export class ScreenshotButton extends React.Component {
  constructor(props) {
    super();
    this.state = {
      isOpen: false,
      src:
        window.config.backend.http_route +
        "/screenshot?equipment=" +
        props.eq +
        "&srv=" +
        props.srv,
      window: undefined,
    };
  }

  render() {
    return (
      <div>
        <Tooltip
          content={
            this.state.isOpen ? (
              <Trans>hide equipment's screen</Trans>
            ) : (
              <Trans>show equipment's screen</Trans>
            )
          }
        >
          <Button
            icon={this.state.isOpen ? "cross" : "desktop"}
            onClick={(e) => {
              e.stopPropagation();
              if (this.state.isOpen) {
                if (this.state.window !== undefined) {
                  this.state.window.close();
                  this.setState({ isOpen: false, window: undefined });
                }
              } else {
                authenticatedGetFetchBlob(
                  "/screenshot?equipment=" +
                    this.props.eq +
                    "&srv=" +
                    this.props.srv,
                  async (screenshot) => {
                    let img = document.createElement("img");
                    img.id = "imgId";
                    img.src = screenshot;

                    let width = 0;
                    let height = 0;

                    img.onload = function () {
                      width = img.width;
                      height = img.height;

                      try {
                        const _window = window.open(
                          front_basename +
                            `/screenshot/${this.props.srv}/${this.props.eq}`,
                          "Screenshot " + this.props.eq,
                          "width=" +
                            width +
                            ",height=" +
                            height +
                            ",titlebar=no,toolbar=no,menubar=no"
                        );
                        _window.onbeforeunload = () => {
                          this.setState({ window: undefined, isOpen: false });
                        };
                        this.setState({ window: _window, isOpen: true });
                      } catch (e) {
                        console.log(e); //the window's script can fall in abort if the close is during the update of the screenshot
                      }
                    }.bind(this);
                  }
                );
              }
            }}
          />
        </Tooltip>
      </div>
    );
  }
}

export default function Screenshot(props) {
  const { eqId, srvId } = useParams();
  let id = eqId !== undefined ? eqId : props.eq;
  let srv = srvId !== undefined ? srvId : props.srv;
  const [img, setImg] = useState(undefined);
  const [error, setError] = useState(false);

  useEffect(() => {
    authenticatedGetFetchBlob(
      "/screenshot?equipment=" + id + "&srv=" + srv,
      async (res) => {
        // callback
        setImg(res);
      },
      () => {
        // callback
        console.info("ERROR handled");
        setError(true);
      }
    );

    const interval = setInterval(() => {
      try {
        if (!error) {
          authenticatedGetFetchBlob(
            "/screenshot?equipment=" + id + "&srv=" + srv,
            async (res) => {
              setImg(res);
            }
          );
        }
      } catch (e) {
        console.log("error=", e);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [id, srv, error]);

  if (props.minimal === true)
    return (
      <img
        draggable={false}
        src={img}
        style={{ width: "100%" }}
        alt={""}// invisible if not available
      />
    );
  else
    return (
      <Callout
        title={
          <div className="flexbox-center-large">
            {id + ""}
            <Button
              onClick={() => window.close()}
              icon="cross"
              minimal={true}
            />
          </div>
        }
        intent="primary"
        icon="desktop"
      >
        <img
          draggable={false}
          src={img}
          alt={i18n.t("cannot retreive equipment's screen")}
          style={{ width: "100%" }}
        />
      </Callout>
    );
}
